import { Button, Select } from "antd";
import styled from "styled-components";
import { COLORS, SIZES } from "../../../../../../components/layout/theme";

export const Inner = styled.div`
	display: flex;
	min-height: 200px;
	justify-content: flex-start;
	align-items: center;
	flex-direction: column;
	gap: 30px;
`;

export const FilterContainer = styled.div`
	${(props) =>
		props.isMobile
			? `
    display: flex;
    flex-direction: column;
	  justify-content: space-between;
	  align-items: center;
    gap: 20px;
  `
			: `
    display: flex;
	  justify-content: space-between;
	  align-items: center;
    flex-direction: row;
    gap: 40px;
  `}
`;

export const Section = styled.div`
	${(props) =>
		props.isMobile
			? `
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    align-items: center;
    align-content: center;
    gap: 20px;
  `
			: `
    display: flex;
	  justify-content: center;
	  align-items: center;
    flex-direction: row;
    gap: 40px;
  `}
`;

export const AntdButton = styled(Button)`
	border-radius: 20px;
	padding: ${(props) => (props.isMobile ? "18px 20px" : "10px 20px")};
`;

export const QuotationSection = styled.div`
	${(props) =>
		props.isMobile
			? `
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 20px;
    padding: 0 10px;
  `
			: `
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 40px;
    padding: 0 80px;
  `}
`;

export const AntdSelect = styled(Select)`
	 &.ant-select:not(.ant-select-customize-input) .ant-select-selector {
  position: relative;
  background-color: transparent;
  border: 0px solid ${COLORS.Grey};
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);

  &.ant-select-arrow {
      height: 18px;
    }
  

  &.ant-select-selector{
    .ant-select-selection-item {
      font-size: ${SIZES.level7};
      color: ${COLORS.Primary};
    }
  }

  &.ant-select-selector{
    .ant-select-selection-search {
      .ant-select-selection-search-input {
        font-size: ${SIZES.level7};
        color: ${COLORS.Primary};
      }
    }
  }
`;
